import { CATCH_ALL_INSURANCE_OPTIONS } from "@/core/constants";
import type { PatientDetails } from "@/core/types";

import { PatientData } from "../../components/PatientData";

type Props = {
  patientDetails: PatientDetails;
};

export function PatientInsurance({ patientDetails }: Props) {
  const { primary_insurance, secondary_insurance } = patientDetails;

  return (
    <dl className="tw:pb-4">
      <PatientData label="Insurance Company">
        {getFormattedInsuranceCarriers(primary_insurance, secondary_insurance)}
      </PatientData>
    </dl>
  );
}

function getFormattedInsuranceCarriers(
  primaryInsurance: PatientDetails["primary_insurance"],
  secondaryInsurance: PatientDetails["secondary_insurance"],
): string {
  const primaryCarrier = primaryInsurance?.carrier;
  let secondaryCarrier = secondaryInsurance?.carrier;

  if (!primaryCarrier && !secondaryCarrier) return "No insurance selected yet";

  // Don't show secondary catch-all insurances when primary is present
  if (primaryCarrier && CATCH_ALL_INSURANCE_OPTIONS.includes(secondaryCarrier)) {
    secondaryCarrier = undefined;
  }

  const carriers = [primaryCarrier, secondaryCarrier].filter(Boolean);

  return [...new Set(carriers)].join(", ");
}
